import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import requestClient from '../../utils/requestClient';
import Image from '../../components/Elements/Image';
import Video from '../../components/Elements/Video';
import DownloadButton from '../../components/Elements/DownloadButton';

const Article = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [article, setArticle] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    async function getArticle() {
      const response = await requestClient().get(`/api/v2/employer/resources/${id}/`)
      setArticle(response.data.data);
    }
    getArticle();
  }, []);

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this resource?')) {
      return;
    }

    setIsDeleting(true);
    
    try {
      await requestClient().delete(`/api/v2/employer/resources/${id}/`);
      
      // Navigate to resources list with success message
      navigate('/employer/resources', { 
        state: { 
          successMessage: 'Resource deleted successfully' 
        } 
      });
    } catch (error) {
      console.error('Failed to delete resource:', error);
      alert('Failed to delete resource. Please try again.');
      setIsDeleting(false);
    }
  };

  return (article ?
    <main>
      <article className='bg-white'>
        <div className='container py-8 lg:py-12'>
          <div className='flex items-center justify-between mb-8'>
            <nav className='hidden lg:block'>
                <ul className='text-sm uppercase flex items-center'>
                    <li>
                        <Link to="/resources">Resources</Link>
                        <span className='mx-2'>/</span>
                    </li>
                    <li className='text-purple font-bold'>
                        {article.title}
                    </li>
                </ul>
            </nav>
            <div className='flex relative overflow-hidden pl-[40px] flex lg:w-auto'>
                <Link to={`edit`}>
                    <button className='btn btn-invert w-full m-1 lg:w-auto'>Edit</button>
                </Link>
                <button 
                    className='btn btn-red w-full m-1 lg:w-auto' 
                    onClick={handleDelete}
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </button>
            </div>
          </div>
          <Link to={`/resources`} className="flex items-center mb-8 lg:hidden">← RESOURCES</Link>
          <div className='max-w-[768px] mx-auto'>
            <h1 className='mb-8'>{article.title}</h1>
            
            {article.video ? (
                <Video src={article.video} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
              ) : article.image ? (
                <Image src={article.image} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
              ) : null}

            {article.pdf_document && <DownloadButton content={article.pdf_document} />}

            <section>
              {article.additional_information ? (
                <div className="mt-8 prose whitespace-pre-line">
                  <p>{article.additional_information}</p>
                </div>
              ) : null}
            </section>
          </div>
        </div>
      </article>
    </main>
    : null);
};

export default Article;